export default __webpack_public_path__ + "static/media/ie.c92e4dc6.jpg";